import { render, staticRenderFns } from "./MusicTempManage.vue?vue&type=template&id=10861923&scoped=true"
import script from "./MusicTempManage.vue?vue&type=script&lang=js"
export * from "./MusicTempManage.vue?vue&type=script&lang=js"
import style0 from "./MusicTempManage.vue?vue&type=style&index=0&id=10861923&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10861923",
  null
  
)

export default component.exports